
  import { Component, Vue ,Inject, Watch,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    private list = []
    private msg:any = {}
    @Inject() information:any
    @Inject() editinfo:any
    get value(){
      return this.information
    }
    get editmsg(){
      return this.information.find(v=>{
        return v.key==this.modekey
      })
    }
    @Watch('editmsg',{deep:true})
    private getmsg(e){
      this.msg = e
    }
  }
